var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('main-header-nav',{attrs:{"content":'我的项目'}}),_c('project-cost-estimate-list',{attrs:{"type":'myself'}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }